/* ------
   Slider
   ---------*/

$(document).ready(function() {
    var slider = $('#slider');
    if (slider.length) {
        var hammer = new Hammer(slider[0]);
        hammer.on('swipeleft', function(ev) {
            slider.carousel('next');
        });
        hammer.on('swiperight', function(ev) {
            slider.carousel('prev');
        });
    }
});
